import { LegalLayout } from "@/components/legal/LegalLayout";

const KvkkBasvuruFormuPage = () => (
  <LegalLayout
    title="KVKK Başvuru Formu"
    description="6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında haklarınızı kullanmak için bu başvuru formunu doldurabilirsiniz."
    path="/kvkk-basvuru-formu"
  >
    <p>
      6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca veri sorumlusu sıfatıyla hareket eden İns
      Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti. olarak KVKK’nın 11. maddesinde sayılan haklarınıza ilişkin
      taleplerinizi yazılı olarak veya kayıtlı elektronik posta (KEP) adresiniz ile iletebilirsiniz. Aşağıdaki form
      taleplerinizi tarafımıza ulaştırmanıza yardımcı olmak üzere hazırlanmıştır.
    </p>

    <h2>1. Başvuru Sahibi Bilgileri</h2>
    <ul>
      <li>Ad Soyad / Unvan</li>
      <li>T.C. Kimlik No / Pasaport No</li>
      <li>Telefon Numarası</li>
      <li>E-posta Adresi</li>
      <li>Tebligata Esas Adres</li>
    </ul>

    <h2>2. İletişim Tercihi</h2>
    <p>Lütfen cevabın tarafınıza hangi yöntemle iletilmesini istediğinizi belirtiniz:</p>
    <ul>
      <li>E-posta (tercihen <strong>info@insorganizasyon.org</strong> üzerinden iletişim kurulur)</li>
      <li>Posta</li>
      <li>KEP Adresi</li>
    </ul>

    <h2>3. Talep Konusu</h2>
    <p>KVKK’nın 11. maddesi uyarınca kullanmak istediğiniz hakları işaretleyiniz:</p>
    <ul>
      <li>Kişisel verilerimin işlenip işlenmediğini öğrenmek</li>
      <li>İşlenmişse buna ilişkin bilgi talep etmek</li>
      <li>İşleme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenmek</li>
      <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilmek</li>
      <li>Eksik veya yanlış işlenmişse düzeltilmesini istemek</li>
      <li>KVKK’nın 7. maddesi kapsamında silinmesini veya yok edilmesini istemek</li>
      <li>Bilgilerin düzeltilmesi / silinmesi taleplerinin aktarıldığı üçüncü kişilere bildirilmesini istemek</li>
      <li>Oluşan zararın giderilmesini talep etmek</li>
    </ul>

    <h2>4. Talebin Detayları</h2>
    <p>
      Lütfen talebinize ilişkin ayrıntılı açıklamayı, varsa dayanak belgeleri ve başvurunuzla ilgili diğer bilgileri bu
      bölümde paylaşınız. Talebinizi netleştirmek amacıyla ek belge sunmanız gerekebilir.
    </p>

    <h2>5. İmza ve Onay</h2>
    <p>
      İşbu formu imzalayarak veya güvenli elektronik imza ile göndererek talep ettiğiniz haklara ilişkin başvurunuzu
      tamamlayabilirsiniz. Şirketimiz talebinizi aldıktan sonra azami 30 gün içerisinde yanıt verecektir. Başvurularınızı
      aşağıdaki kanallar üzerinden iletebilirsiniz:
    </p>
    <ul>
      <li><strong>Adres:</strong> Çamlıca Mah. 168. Cad. No: 3 Yenimahalle / Ankara</li>
      <li><strong>KEP:</strong> insorganizasyon@hs03.kep.tr (mevcutsa)</li>
      <li><strong>E-posta:</strong> info@insorganizasyon.org</li>
      <li><strong>Telefon:</strong> +90 541 587 88 22</li>
    </ul>

    <p>
      Başvurunuzun hızlıca sonuçlanabilmesi için kimliğinizin doğrulanmasına yönelik ek bilgi ve belgeler talep edilebileceğini
      hatırlatırız.
    </p>
  </LegalLayout>
);

export default KvkkBasvuruFormuPage;
